import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            <div className="container navbar-container">
                <Link to="/" className="navbar-logo">
                    Urban Bites
                </Link>
                <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
                    <Link to="/" onClick={toggleMenu}>HOME</Link>
                    <Link to="/menu" onClick={toggleMenu}>Menu</Link>
                    <Link to="/catering" onClick={toggleMenu}>Catering Menu</Link>
                    <Link to="/gallery" onClick={toggleMenu}>GALLERY</Link>
                    <Link to="/contact" onClick={toggleMenu}>CONTACT</Link>
                    <Link to="/franchise" onClick={toggleMenu}>Franchise</Link>

                    {/* <a href="https://order.online/business/-648326" target="_blank" rel="noopener noreferrer" className="btn-primary" style={{ marginLeft: '15px' }}>Order Online</a> */}
                </div>
                <div className="navbar-toggle" onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
